import React from 'react';
import {OrderApi, OrderStatus, OrderTrackingStatus, OrderType} from "../../../../services/Api/types";
import OrderDeliveryPreparationStatusComponent from "./Delivery/OrderDeliveryPreparationStatusComponent";
import OrderOtherTypePreparationStatusComponent from "./OrderOtherTypePreparationStatusComponent";
import {RootState} from "../../../../../reducers";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {connect} from "react-redux";

interface OwnProps {
    order: OrderApi;
    onUpdate: (order: OrderApi) => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const OrderPreparationStatusComponent = ({order, onUpdate, config}: Props) => {
    if ((order.status !== OrderStatus.ACCEPTED && order.status !== OrderStatus.CLOSED) || !config) return <></>;

    const getParsedOrderTrackingStatus = () => {
        if (!order.tracking_status || order.tracking_status === OrderTrackingStatus.NEW) return OrderTrackingStatus.PREPARATION;

        if (order.tracking_status === OrderTrackingStatus.DELIVERY) return OrderTrackingStatus.READY;

        return order.tracking_status;
    }

    return (
        <div className="container-fluid">
            <div className="summary-order-preparation-status-container">
                {
                    order.type === OrderType.DELIVERY ? (
                        <OrderDeliveryPreparationStatusComponent
                            order={order}
                            onUpdate={onUpdate}
                            orderTrackingStatus={getParsedOrderTrackingStatus()}
                            config={config}
                        />
                    ) : (
                        <OrderOtherTypePreparationStatusComponent
                            order={order}
                            onUpdate={onUpdate}
                            config={config}
                            orderTrackingStatus={getParsedOrderTrackingStatus()}/>
                    )
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config)
});

const connector = connect(mapStateToProps);

export default connector(OrderPreparationStatusComponent);